import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import BackendConnectionSettings from '../components/BackendConnectionSettings';
import { ResetPasswordForm } from '../components/AccountSecurity';

const { Title, Text } = Typography;

function Login() {
  const { login, loading } = useAuth();
  const [form] = Form.useForm();
  const [forgot, setForgot] = useState(false);

  const handleSubmit = async (values) => {
    await login(values);
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
          borderRadius: '12px'
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
          <div>
            <Title level={2} style={{ marginBottom: 8, color: '#1890ff' }}>
              轻锋机器人管理后台
            </Title>
            <Text type="secondary">{forgot ? '找回账户密码' : '请登录您的账户'}</Text>
          </div>

          {forgot ? <div style={{ textAlign: 'left' }}><ResetPasswordForm onBack={() => setForgot(false)} /></div> : <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            size="large"
          >
            <Form.Item
              name="username"
              rules={[{ required: true, message: '请输入用户名' }]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="用户名"
                autoComplete="username"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="密码"
                autoComplete="current-password"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
                style={{
                  height: '48px',
                  fontSize: '16px',
                  borderRadius: '8px'
                }}
              >
                登录
              </Button>
            </Form.Item>
            <Button type="link" onClick={() => setForgot(true)} block>忘记密码？</Button>
          </Form>}
          <BackendConnectionSettings />
        </Space>
      </Card>
    </div>
  );
}

export default Login;
